<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('fileName')" class="col-sm-4 col-form-label">URL</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('fileName')" v-model.lazy="fileName">
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-8 offset-4">
          <button type="button" class="btn btn-block btn-primary" @click="fetch()">Fetch</button>
        </div>
      </div>
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>

      <dataset-table :dataset-id="datasetId"></dataset-table>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <dataset-settings :window-id="windowId" :dataset-id="datasetId"></dataset-settings>
    </window-tab>
  </window>
</template>

<script>
  import { uuid } from '../lib'
  import { windowPropsMixin } from '../mixins'
  import * as mutation from '../store/mutation-types'
  import DatasetSettings from './dataset-settings.vue'
  import DatasetTable from './dataset-table.vue'

  export default {
    name: 'vertical-life-dataset',
    components: {DatasetSettings, DatasetTable},
    mixins: [windowPropsMixin],
    data () {
      return {
        errorMessage: null
      }
    },
    computed: {
      datasetId () {
        return this.$store.getters.windowData(this.windowId).contentId
      },
      dataset () {
        return this.$store.getters.dataset(this.datasetId) || {}
      },
      title () {
        return this.dataset.title || 'Unnamed dataset'
      },
      fileName: {
        get () {
          return this.dataset.fileName || ''
        },
        set (val) {
          this.$store.commit(mutation.DATASET_UPDATE_META, {
            datasetId: this.datasetId,
            fileName: val,
            emit: true
          })
        }
      }
    },
    mounted () {
      if (this.fileName && (this.dataset.records || []).length === 0) {
        this.fetch()
      }
    },
    methods: {
      fetch () {
        console.log('[vertical-life-dataset] fetching data')
        this.errorMessage = null
        const request = new XMLHttpRequest()
        request.open('GET', this.fileName, true)
        // TODO: This auth token should be taken from the settings
        request.setRequestHeader('X-Auth-Token', '63b0083436935fc8492e16de93cfa929485a5ce3')
        request.onload = function (event) {
          if (!event.target) {
            this.errorMessage = 'Unknown error'
            return
          }

          if (event.target.status !== 200) {
            this.errorMessage = event.target.statusText
            return
          }
          const response = JSON.parse(event.target.response)

          const rows = response.ranking || response.startlist || []

          const columnMap = {
            // 'starting_order': 'SORT_ORDER', // TODO: Is this needed somewhere?
            'firstname': 'FIRST NAME',
            'lastname': 'LAST NAME',
            'bib': 'BIB',
            'country': 'COUNTRY',
            'rank': 'RANK',
            'score': 'SCORE'
          }

          const records = this.mergeRecords(rows, columnMap)
          const columns = Object.values(columnMap)

          this.$store.commit(mutation.DATASET_UPDATE_RECORDS, {
            datasetId: this.datasetId,
            columns: columns,
            records: records.map(record => {
              record.recordId = record.recordId || uuid()
              return record
            }),
            emit: true
          })
        }.bind(this)
        request.onerror = function (event) {
          console.log(event)
          this.errorMessage = JSON.stringify(event)
        }.bind(this)
        request.send()
      },
      mergeRecords (rows, columnMap) {
        const records = this.dataset.records || []
        const newRecords = rows.map(row => {
          const record = {}
          Object.keys(columnMap).forEach(key => {
            record[columnMap[key]] = row[key]
          })
          return record
        })
        newRecords.forEach(newRecord => {
          const oldRecord = records.find(r => r.BIB === newRecord.BIB)
          if (!oldRecord) {
            records.push(newRecord)
          } else {
            Object.keys(newRecord).forEach(key => {
              oldRecord[key] = newRecord[key] || oldRecord[key]
            })
          }
        })
        return records
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/vertical-life-dataset.vue